import { useContext } from 'react'
import { StoryblokContext } from '../layouts'

const useData = () => useContext(StoryblokContext)

export default useData
